import ToastMessage from 'components/basic/ToastMessage';

///////////// page error /////////////////////
const ShowPageError = ({error}) => {
  let details;
  error = error.data || error; //get error data
  if (error.validator_errors) {
    details = (
      <>
        {error.validator_errors.map((v, i) => (
          <p key={i}>{v}</p>
        ))}
      </>
    );
  } else if (error.message) {
    details = <p>{error.message}</p>;
  }

  return <ToastMessage message="Lỗi khi lấy dữ liệu" type="error" details={details} />;
};

export default ShowPageError;
